import React, { Component, PropTypes } from 'react';
import './Duplicate.css';

class Duplicate extends Component {

  render() {
    return (
      <svg onClick={this.props.onClick} className="duplicateIcon__wrap" xmlns="http://www.w3.org/2000/svg" viewBox="2584.9 -68 18.938 21.152">
        <title>{this.props.title}</title>
        <g id="Group_400" className="duplicateIcon" data-name="Group 400" transform="translate(1521 -245)">
          <path id="Path_232" data-name="Path 232" className="cls-1" d="M18.938,3.838V3.559H13.22V0H0V17.561H5.7v3.582c.078,0,.133.009.183.009q4.529,0,9.057,0a.475.475,0,0,0,.293-.128q1.784-1.743,3.554-3.495a.527.527,0,0,0,.142-.334Q18.941,10.514,18.938,3.838ZM1.285,16.258V1.281H11.916V12.232H8.065v4.026ZM11.523,13.54c-.682.714-1.4,1.459-2.164,2.26V13.54Zm3.564,5.851V17.122h2.141Zm2.548-3.573H13.778v4.026H7V17.557h.352c.618,0,1.235,0,1.853,0a.487.487,0,0,0,.311-.128q1.777-1.729,3.541-3.477a.555.555,0,0,0,.146-.352c.009-2.8,0-5.608,0-8.412V4.876H17.63C17.635,8.522,17.635,12.154,17.635,15.819Z" transform="translate(1063.9 177)"/>
        </g>
      </svg>
    );
  }
}

Duplicate.propTypes = {
  onClick: PropTypes.func.isRequired
};

export default Duplicate;



/** WEBPACK FOOTER **
 ** ./src/icons/Duplicate/index.js
 **/